import routes from "./router/routes"

export function asyncVisitModule({ router }) {
  for (const route of routes) router.addRoute("dashboard", route)
}
